module.exports = __webpack_public_path__ + "static/d1537fbd27-cd4ccba4998cae4a43be77e8c91d7e29.jpg";